import React from 'react';

import ShareDocumentModal from 'containers/DocumentsDetails/DocumentPermissions/ShareDocumentModal';
import { SaveVersionModal } from 'containers/Tiptap/components/CreateVersionModal';

interface EditorModalsProps {
  shareModalOpen: boolean;
  entityId: string;
  onCloseShareModal: () => void;
  hasPublishedVersion: boolean;
  saveVersionModalOpen: boolean;
  onCloseSaveVersionModal: () => void;
  onConfirmSaveVersion: (versionName: string) => void;
  isSavingVersion: boolean;
  nextVersionNumber: number;
}

export const EditorModals: React.FC<EditorModalsProps> = ({
  shareModalOpen,
  entityId,
  onCloseShareModal,
  hasPublishedVersion,
  saveVersionModalOpen,
  onCloseSaveVersionModal,
  onConfirmSaveVersion,
  isSavingVersion,
  nextVersionNumber,
}) => (
  <>
    <ShareDocumentModal open={shareModalOpen} entityId={entityId} onClose={onCloseShareModal} />
    <SaveVersionModal
      open={saveVersionModalOpen}
      onClose={onCloseSaveVersionModal}
      onConfirm={onConfirmSaveVersion}
      isSaving={isSavingVersion}
      nextVersionNumber={nextVersionNumber}
    />
  </>
);
